import React, { useEffect, useState } from "react";
import CustomRecordingHistory from "../ui/CustomHistoryCard";
import { FiPlus } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { getAllLectureConverter } from "../api/api";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { IoClose } from "react-icons/io5";

function LectureTranscriptHistory() {
  const navigate = useNavigate();
  const [selectedItem, setSelectedItem] = useState(null);
  const [lectures, setLectures] = useState([]);
  useEffect(() => {
    fetchLectureAnalysis();
  }, []);

  const fetchLectureAnalysis = async () => {
    try {
      const response = await getAllLectureConverter();
      if (response && response.data) {
        setLectures(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching lecture analysis:", error);
      toast.error("Failed to fetch lecture analysis data.");
    }
  };

  return (
    <div>
      <div className="p-5">
        {/* Header */}
        <div className="modalHeading py-3 d-flex justify-content-between align-items-center">
          <h3 className="h4 m-0 fw-bold">Recording History</h3>
          <button
            className="mainBlue2 py-2 px-3 rounded d-flex align-items-center"
            onClick={() => navigate("/lecture-convertor")}
            style={{ gap: "8px" }}
          >
            <FiPlus size={22} />
            <span>Add Recording</span>
          </button>
        </div>
        <CustomRecordingHistory
          data={lectures}
          handleSelectItem={(item) => setSelectedItem(item)}
        />
      </div>

      <Modal
        show={!!selectedItem}
        onHide={() => setSelectedItem(null)}
        size="lg"
        centered
        className="addToGroupModal"
      >
        <Modal.Body>
          <div className="d-flex justify-content-between align-items-center pb-2 mb-3 border-bottom">
            <h3 className="fw-bold mb-0">Lecture Analysis</h3>
            <button className="modalCloseBtn" onClick={() => setSelectedItem(null)}>
              <IoClose size={24} />
            </button>
          </div>
          {selectedItem ? (
            <div>
              <div className="row mb-4">
                <div className="col-md-6 mb-3 mb-md-0">
                  <div className="d-flex flex-column">
                    <label className="cardSubtitle fw-semibold mb-2">Input file</label>
                    <audio controls className="w-100">
                      <source
                        src={
                          selectedItem?.audio_file_path
                            ? `https://visionemptrack.greymatterz.com/${selectedItem.audio_file_path}`
                            : ""
                        }
                      />
                      Your browser does not support the audio element.
                    </audio>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="d-flex flex-column">
                    <label className="cardSubtitle fw-semibold mb-2">Output File</label>
                    <audio controls className="w-100">
                      <source
                        src={
                          selectedItem?.audio_response_path
                            ? `https://visionemptrack.greymatterz.com/${selectedItem.audio_response_path}`
                            : ""
                        }
                      />
                      Your browser does not support the audio element.
                    </audio>
                  </div>
                </div>
              </div>
              {selectedItem?.transcipt && (
                <div className="mb-4">
                  <label className="cardSubtitle fw-semibold mb-2">Transcript</label>
                  <div className="bg-light p-3 rounded border" style={{ whiteSpace: "pre-line" }}>
                    {selectedItem.transcipt}
                  </div>
                </div>
              )}
              {selectedItem?.translated_transcript && (
                <div className="mb-4">
                  <label className="cardSubtitle fw-semibold mb-2">Translated Transcript</label>
                  <div className="bg-light p-3 rounded border" style={{ whiteSpace: "pre-line" }}>
                    {selectedItem.translated_transcript}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <p className="card-text">No transcript available.</p>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default LectureTranscriptHistory;
